module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-braces-faq"
  }, [_c('TitleTrigger', {
    staticClass: "tab-braces-faq__title-trigger",
    attrs: {
      "props": 1
    }
  }), _c('div', {
    staticClass: "tab-braces-faq__title",
    class: {
      active: this.titleActive
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), _c('div', {
    staticClass: "tab-braces-faq__container"
  }, [_c('div', {
    staticClass: "tab-braces-faq__row",
    style: ({
      height: Math.ceil(_vm.props.question.length / 3) * 7 + 'rem'
    })
  }, _vm._l((_vm.props.question), function(tile, i) {
    return _c('div', {
      key: i,
      staticClass: "tab-braces-faq__tile",
      class: {
        active: _vm.tab === i, entering: _vm.delay === i
      },
      style: ({
        top: Math.floor(i / 3) * 7 + 'rem'
      }),
      on: {
        "click": function($event) {
          _vm.showTab(i)
        }
      }
    }, [_c('div', {
      staticClass: "tab-braces-faq__question"
    }, [_c('div', {
      staticClass: "tab-braces-faq__question--text",
      domProps: {
        "innerHTML": _vm._s(tile.question)
      }
    }), _c('div', {
      staticClass: "tab-braces-faq__question--chevron",
      class: {
        active: _vm.tab === i
      }
    }, [_c('span'), _c('span')])]), _c('transition', {
      attrs: {
        "name": "tab-braces-faq__answer-transition"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (i === _vm.content),
        expression: "i === content"
      }],
      staticClass: "tab-braces-faq__answer",
      domProps: {
        "innerHTML": _vm._s(tile.answer)
      }
    })])], 1)
  }))]), _c('div', {
    staticClass: "tab-braces-faq__container tab-braces-faq__container--mobile"
  }, [_c('div', {
    staticClass: "tab-braces-faq__row"
  }, _vm._l((_vm.props.question), function(tile, i) {
    return _c('div', {
      key: i,
      staticClass: "tab-braces-faq__tile",
      class: {
        active: _vm.tab === i
      },
      on: {
        "click": function($event) {
          _vm.showTabMobile(i)
        }
      }
    }, [_c('div', {
      staticClass: "tab-braces-faq__question"
    }, [_c('div', {
      staticClass: "tab-braces-faq__question--text",
      domProps: {
        "innerHTML": _vm._s(tile.question)
      }
    }), _c('div', {
      staticClass: "tab-braces-faq__question--chevron",
      class: {
        active: _vm.tab === i
      }
    }, [_c('span'), _c('span')])]), _c('transition', {
      attrs: {
        "name": "tab-braces-faq__answer-transition"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (i === _vm.delay),
        expression: "i === delay"
      }],
      staticClass: "tab-braces-faq__answer",
      domProps: {
        "innerHTML": _vm._s(tile.answer)
      }
    })])], 1)
  }))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d0dceba","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/tab/tab-braces-faq/tab-braces-faq.pug
// module id = 632
// module chunks = 1